module.exports = __webpack_public_path__ + "img/bg4.556a4039.png";